import { gql } from "@apollo/client";

export const GET_COMPANY_FIRM_QUERY = gql`
query GetCompanies($type: String,$startsWith: String, $pageOptions: PageOptions, $sortOptions: [companySortOptions], $filters: [companyFilters]) {
  getCompanies(type: $type,startsWith: $startsWith, pageOptions: $pageOptions, sortOptions: $sortOptions,  filters: $filters) {
    success
    message
    data {
      arcimedes_row_id
        name
        address
        city
        state
        zip
        phone
        parent_firm
        website
        company_id
        firm
        email
        company_type
    }
    totalCount
    error
  }
}

`
////this all are removed from above firms query
// deleted
// arcimedes_created
// arcimedes_created_by
// arcimedes_modified
// arcimedes_modified_by
export  const  GET_ALL_COMPANIES_FIRM_QUERY = gql`
query GetAllCompanies($pageOptions: PageOptions) {
  getAllCompanies(pageOptions: $pageOptions) {
     firms {
      company_id
      company_type
      arcimedes_row_id
      name
      address
      city
      state
      zip
      phone
      parent_firm
      website
      email
      deleted
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
    message
    success
    totalCount
  }
}
`


export const GET_COMPANY_FIRM_BY_ID = gql`
query GetCompanyById($companyId: Float) {
  getCompanyById(company_id: $companyId) {
    company {
      arcimedes_row_id
        name
        address
        city
        state
        zip
        phone
        parent_firm
        website
        deleted
         company_id
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
    }
    error
    message
    success
  }
}
`

export const GET_COMPANY_FIRM_BY_ARC_ID = gql`
query getCompanyByArcId($arcId: Float) {
  getCompanyByArcId(arcimedes_row_id: $arcId) {
    company {
      arcimedes_row_id
        name
        address
        city
        state
        zip
        phone
        parent_firm
        website
        deleted
         company_id
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
    }
    error
    message
    success
  }
}
`

export const GET_ALL_DUPLICATE_COMPANIES_LIST = gql`
query GetDuplicateCompanies($name: String!,$sortOptions: [SortOptions]) {
  getDuplicateCompanies(name: $name,sortOptions: $sortOptions) {
    success
    message
    firms {
      company_id
      company_type
      arcimedes_row_id
      name
      address
      city
      state
      zip
      phone
      parent_firm
      website
      email
      firm
    }
    error
  }
}
`